export enum EServiceRequestStatus {
  Contacted = 'contacted',
  ExpertiseInProgress = 'expertise_in_progress', // Temporary status for demo purposes
  Lost = 'lost',
  QuoteInProgress = 'quote_in_progress',
  Received = 'received',
  Success = 'success',
  Trashed = 'trashed',
  WorkInProgress = 'work_in_progress',
}
